export enum DepartmentTypes {
  /// پشتیبانی
  Support = 1,
  /// پشتیبانی فنی
  TechnicalSupport,
  /// پشتیبانی پرسنل
  InstituteStaff,
}

export default DepartmentTypes;
